<template>
  <div>
    <h1>Загрузка...</h1>
  </div>
</template>

<script>
export default {
  name: 'Token',
  created() {
    try {
      const { token, redirect } = this.$route.query
      this.$auth.token(null, token, false)
      this.$auth.fetch().finally(() => {
        this.$router.push(redirect || '/')
      })
    } catch (e) {
      console.warn(e)
      this.$router.push('/')
    }
  },
}
</script>
